import React from "react";
import { useNavigate } from "react-router-dom";
import { FaLinkedin, FaYoutube } from "react-icons/fa";
import "../styles/Footer.css";

const Footer = () => {
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  return (
    <footer className="footer" id="page-footer">
      <div className="footer-container">

        {/* Company Info Section */}
        <div className="footer-section footer-company-info">
          <h1 className="footer-title">Instilit</h1>
          <p>Learn Earn</p>
          <div className="social-links1">
            
            <a
              href="https://www.linkedin.com/in/sharat-manikonda/"
              className="social-icon"
              aria-label="LinkedIn"
              target="_blank"
              rel="noopener noreferrer"
            > 
              <FaLinkedin size={32} className="Licon"/>
            
              
            </a>
            <a
              href="https://www.youtube.com/@sharatmanikonda"
              className="social-icon"
              aria-label="YouTube"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaYoutube size={32} className="Licon"/>
              
            </a>
          </div>
        </div>

        {/* Important Links Section */}
        <div className="footer-section footer-important-links">
          <div className="title-difference">
            <h3>Important Links</h3>
          </div>
          <ul>
            <li>
              <button
                className="footer-link-button"
                onClick={() => handleNavigation("/")}
              >
                Home
              </button>
            </li>
            <li>
              <button
                className="footer-link-button"
                onClick={() => handleNavigation("/about-us")}
              >
                About Us
              </button>
            </li>
            <li>
              <button
                className="footer-link-button"
                onClick={() => handleNavigation("/coursesoffered")}
              >
                Our Products
              </button>
            </li>
          </ul>
        </div>

        {/* Contact Section */}
        <div className="footer-section footer-contact-info">
          <div className="title-difference">
            <h3>Contact</h3>
          </div>
          <p>
            <strong>Email: </strong>
            <a
              href="https://mail.google.com/mail/?view=cm&to=info@instilit.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              info@instilit.com
            </a>
          </p>
        </div>

      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <p>&copy; 2025 Instilit. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
